<template>
  <!-- eslint-disable max-len -->
  <div>
    <nav
      class="bg-gray-900 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0"
      style="height: 50px;"
    >
    </nav>
    <div class="flex flex-col md:flex-row">
      <div class="main-content flex-1 bg-gray-100 mt-12 md:mt-2">
        <div class="bg-blue-800 p-2 shadow text-xl text-white">
          <div class="bg-grey-lighter min-h-screen flex flex-col">

            <div
              class="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2"
            >
              <div class="bg-white px-6 pt-4 pb-8 rounded shadow-md text-black w-full" style="width: 600px;" >
                <img class="m-auto mb-10" src="@/assets/musicverse-logo.png" style="width: 150px"/>
                <h2 class="mb-8 text-xl text-left" v-if="!error" >
                  We have sent an email with a confirmation link to your email address. Please click the confirmation link.<br/><br/>
                  If you do not receive a confirmation email, please check your spam folder. Also, please verify that you entered a valid email address in our sign-up form.<br/><br/>
                  If you still didn't receive the confirmation email to {{ this.email }} , click <a class="text-blue-400 cursor-pointer" @click="nextProcess" >here</a> to resend.
                </h2>
                <h1 class="mb-8 text-3xl text-center" v-if="error" >Sorry!</h1>
                <h2 class="mb-8 text-xl text-left" v-if="error" >
                  {{ error }}
                </h2>
                <h1 class="mb-8 text-center" v-if="error" >
                  <router-link class="text-blue-400 cursor-pointer" :to="{ name: 'Signin' }" >back to login page</router-link>
                </h1>
              <!-- <h3 v-if="!isSuccessVerification" class="mb-8 text-lg font-bold">{{ email }}</h3> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isEmailHasBeenSend" class="fixed bottom-0 right-0 m-8 w-5/6 md:w-full max-w-sm" @click="toggleToast()" >
      <input type="checkbox" class="hidden" id="footertoast" >

      <label class="close cursor-pointer flex items-start justify-between w-full p-2  bg-green-500 h-24 rounded shadow-lg text-white" title="close" for="footertoast">
        Email has been sent

        <svg class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
        </svg>
      </label>
    </div>
  </div>
  <!-- eslint-enable max-len -->
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SignupSuccess',
  data: () => ({
    message: '',
    error: null,
    isEmailHasBeenSend: false,
  }),
  props: {
    email: {
      type: String,
      default: null,
    },
  },
  async mounted() {
    if (this.email) {
      await this.nextProcess();
    }
  },
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
  },
  methods: {
    ...mapActions('EmailModule', ['requestResendVerification']),
    toggleToast() {
      this.isEmailHasBeenSend = !this.isEmailHasBeenSend;
    },
    async nextProcess() {
      try {
        await this.requestResendVerification(this.email);
        this.isEmailHasBeenSend = true;
        setTimeout(this.toggleToast, 2000);
      } catch (err) {
        this.error = err.message;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/SendVerification.vue